/* eslint-disable no-use-before-define */
import { show, isCusip, arrayUnique, isObject } from '../../twd'

const SEARCH_TERMS = {
    'cmo,abs,mbs,cmos,asset-backed,asset backed,asset back,mortgage-backed,mortgage backed,mortgage back,mortgage': {
        holdInvType:['O', 'R', 'K']
    },
    '*pass': {
        holdInvType:['O', 'R', 'K']
    },

    'corp,corps,corporate,corporates,corporate bond,corporate bonds': {
        holdInvType:['C']
    },

    'muni,munis,municipal,municipals,municipal bond,municipal bonds': {
        holdInvType:['M']
    },

    'agency bonds,agencies,agency': {
        holdInvType:['A']
    },
    'ati,aid to israel': {
        holdInvType:['A'], holdAgencyType: ['ATI']
    },
    'dn,discount notes': {
        holdInvType:['A'], holdAgencyType: ['B']
    },
    'famc,federal agriculture mortgage corporation': {
        holdInvType:['A'], holdAgencyType: ['FAMC']
    },
    'ffcb,federal farm credit banks': {
        holdInvType:['A'], holdAgencyType: ['FFCB']
    },
    'fha,farmers home administration': {
        holdInvType:['A'], holdAgencyType: ['FHA']
    },
    'fhlb,federal home loan banks': {
        holdInvType:['A'], holdAgencyType: ['FHLB']
    },
    'fhlmc,federal home loan mortgage corporation': {
        holdInvType:['A'], holdAgencyType: ['FHLMC']
    },
    'fico,financing corp': {
        holdInvType:['A'], holdAgencyType: ['FICO']
    },
    'fjob,federal judiciary office building': {
        holdInvType:['A'], holdAgencyType: ['FJOB']
    },
    'fnma,federal national mortgage association': {
        holdInvType:['A'], holdAgencyType: ['FNMA']
    },
    'gnma,government national mortgage association': {
        holdInvType:['A'], holdAgencyType: ['GNMA']
    },
    'hud,housing & urban development': {
        holdInvType:['A'], holdAgencyType: ['HUD']
    },
    'sba,small business administration': {
        holdInvType:['A'], holdAgencyType: ['SBA']
    },
    'slma,student loan marketing association': {
        holdInvType:['A'], holdAgencyType: ['SLMA']
    },
    'tva,tennessee valley authority': {
        holdInvType:['A'], holdAgencyType: ['TVA']
    },

    'cd,cds,brokered cds,certificate of deposit,certificates of deposit': {
        holdInvType:['S']
    },

    'structured': {
        holdInvType:['L']
    },

    'treasury,treasuries,treasurys,us treasuries,s. treasuries': {
        holdInvType:['T']
    },
    't bill,t bills,t-bill,treasury bill,treasury bills': {
        holdInvType:['T'], holdTreasuryType: ['Bills']
    },
    't note,t notes,t-note,treasury note,treasury notes': {
        holdInvType:['T'], holdTreasuryType: ['Notes']
    },
    't bond,t bonds,t-bond,treasury bond,treasury bonds': {
        holdInvType:['T'], holdTreasuryType: ['Bonds']
    },
    'tips,tip': {
        holdInvType:['T'], holdTreasuryType: ['TIPS']
    },
    'strips,strip': {
        holdInvType:['T'], holdTreasuryType: ['STRIPS']
    },
    'frn': {
        holdInvType:['T'], holdTreasuryType: ['FRN']
    },

    'treasury auction,treasury auctions,auction,auctions': () => {
        show('tools.treasury-auctions')
    },

}

export const getGenericSearch = (txt) => {
    if (!txt) return

    let cusipSearch = getCusipList(txt)
    if (cusipSearch) return cusipSearch

    let ltext = txt.toLowerCase()

    let [_, sp] =  Object
        .entries(SEARCH_TERMS)
        .find( ([terms,value]) => {
            return (terms[0]==='*' && ltext.indexOf(terms.substring(1))===0)
                || (terms.split(',').map(a => a.trim()).indexOf(ltext)>=0)
        })
        || []

    if (sp && isObject(sp)) {
        sp = Object.assign({
            offeringType: ['ask-side'],
        }, sp)
    }

    return sp
}

const getCusipList = (txt) => {

    let ls = arrayUnique(txt.split(',').map(a => a.trim().toUpperCase()).filter(Boolean))
    if (ls.length === 0) return

    let notCusip = ls.findIndex(a => !isCusip(a))>=0
    if (notCusip) return

    if (ls.length>100) return { error: 'Please enter up to 100 comma separated CUSIPs' }

    return {
        holdCusip: ls,
        holdIdentifierLabel: "holdCusip",
        holdIdentifiers: ls,
        offeringType: ['ask-side'],
    }
}



// WEBPACK FOOTER //
// ./src/header/global-search/generic-search.js